export default "__VITE_ASSET__fd2b87ae__"